module.exports = __webpack_public_path__ + "img/组 67.2964a3ec.png";